import axios from "axios";

const API = "https://nathnagribareilly.com/api/index.php";

export const getQuestions = () =>
    axios.get(`${API}?action=getQuestions&_=${new Date().getTime()}`);

export const addQuestion = (data) => axios.post(`${API}?action=addQuestion`, data);

export const addComment = (data) => axios.post(`${API}?action=addComment`, data);

export const likeQuestion = (data) => axios.post(`${API}?action=likeQuestion`, data);

export const deletePostAPI = (post_id) =>
    axios.post(`${API}?action=deletePost`, { post_id });

export const deleteCommentAPI = (comment_id) =>
    axios.post(`${API}?action=deleteComment`, { comment_id });

export const editPostAPI = (postId, text) =>
    axios.post(`${API}?action=editPost`, { post_id: postId, question: text });